/**
 * Angular material knows only 3 colors
 */
export enum MaterialColor {
  Primary = 'primary',
  Accent = 'accent',
  Warn = 'warn',
}
